import { AdminMessage } from "@components/admin/admin-helpers"
import { MediaBlock } from "@components/atoms/MediaBlock"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { defineBlock } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Image",
  category: "media",
  description: "An image block",
  icon: "format-image",
  tags: ["#subpage"],
  flags: {
    fullWidth: true,
  },
}

export default defineBlock("content/image", (props) => {
  const hasContent = !!props.image?.mediaItemUrl
  if (!hasContent && !env.admin) {
    return null
  }

  return (
    <MediaBlock layout={props.layout as any}>
      {hasContent ? (
        <ResponsiveImage {...props.image} />
      ) : (
        env.admin && <AdminMessage className="w-full">No image has been selected</AdminMessage>
      )}
    </MediaBlock>
  )
})
